import { Component } from '@angular/core';

@Component({
  selector: 'app-sarlaft-denied',
  templateUrl: './sarlaft-denied.component.html',
  styleUrl: './sarlaft-denied.component.scss'
})
export class SarlaftDeniedComponent {
  redirect(): void {
    window.location.href = 'https://www.sura.co/';
  }
}
